import { render } from "./TaxpayerFormModal.vue?vue&type=template&id=6d7c1f6a&scoped=true"
import script from "./TaxpayerFormModal.vue?vue&type=script&lang=js"
export * from "./TaxpayerFormModal.vue?vue&type=script&lang=js"

import "./TaxpayerFormModal.vue?vue&type=style&index=0&id=6d7c1f6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7c1f6a"]])

export default __exports__